export { configureDotLottieWasm } from './configureDotLottieWasm';
